module.exports = __webpack_public_path__ + "static/img/cont34 (8).d9aa4f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (8).jpg
// module id = dhLu
// module chunks = 0